import { Autocomplete } from '../../../components/ui';
import type { AutocompleteOption } from '../../../types';

interface IndustryStepProps {
  industry: string;
  onChange: (industry: string) => void;
}

const INDUSTRIES: AutocompleteOption[] = [
  { label: 'Accounting & Finance', keywords: ['CPA', 'bookkeeper', 'tax', 'accountant', 'financial advisor'] },
  { label: 'Advertising & Marketing', keywords: ['agency', 'PR', 'social media', 'SEO', 'branding', 'ads'] },
  { label: 'Agriculture', keywords: ['farming', 'ranch', 'livestock', 'crop'] },
  { label: 'Architecture & Design', keywords: ['architect', 'interior design', 'urban planning'] },
  { label: 'Automotive', keywords: ['car', 'mechanic', 'auto repair', 'dealership', 'detailing'] },
  { label: 'Banking & Financial Services', keywords: ['bank', 'credit union', 'lending', 'mortgage broker'] },
  { label: 'Beauty & Personal Care', keywords: ['salon', 'barbershop', 'spa', 'skincare', 'nail', 'hair'] },
  { label: 'Biotechnology', keywords: ['biotech', 'life sciences', 'genomics'] },
  { label: 'Cleaning Services', keywords: ['janitorial', 'maid', 'pressure washing', 'carpet cleaning'] },
  { label: 'Construction', keywords: ['builder', 'contractor', 'general contractor', 'remodel'] },
  { label: 'Consulting', keywords: ['consultant', 'advisory', 'management consulting', 'strategy'] },
  { label: 'Creative & Design Services', keywords: ['graphic design', 'photography', 'videography', 'branding'] },
  { label: 'E-commerce', keywords: ['online store', 'dropshipping', 'Amazon seller', 'Shopify', 'Etsy'] },
  { label: 'Education', keywords: ['school', 'tutoring', 'training', 'coaching', 'online course'] },
  { label: 'Energy & Utilities', keywords: ['solar', 'oil', 'gas', 'electric', 'renewable'] },
  { label: 'Entertainment & Media', keywords: ['music', 'film', 'podcast', 'streaming', 'content creator'] },
  { label: 'Event Planning & Services', keywords: ['wedding planner', 'catering', 'DJ', 'events'] },
  { label: 'Fashion & Apparel', keywords: ['clothing', 'boutique', 'fashion brand', 'accessories'] },
  { label: 'Fitness & Wellness', keywords: ['gym', 'personal trainer', 'yoga', 'pilates', 'wellness coach'] },
  { label: 'Food & Beverage', keywords: ['restaurant', 'cafe', 'bar', 'bakery', 'food truck', 'catering'] },
  { label: 'Freelance & Gig Work', keywords: ['freelancer', 'independent contractor', 'side hustle', 'gig', 'self-employed'] },
  { label: 'Healthcare & Medical Practice', keywords: ['doctor', 'physician', 'nurse', 'clinic', 'dentist', 'therapist', 'medical'] },
  { label: 'Home Services', keywords: ['plumber', 'electrician', 'HVAC', 'handyman', 'roofing', 'landscaping', 'pest control'] },
  { label: 'Hospitality & Tourism', keywords: ['hotel', 'travel', 'tourism', 'Airbnb', 'vacation rental'] },
  { label: 'Information Technology', keywords: ['IT', 'tech', 'computer', 'cybersecurity', 'MSP', 'tech support'] },
  { label: 'Insurance', keywords: ['insurance agent', 'broker', 'underwriting', 'claims'] },
  { label: 'Legal Services', keywords: ['lawyer', 'attorney', 'law firm', 'paralegal', 'legal'] },
  { label: 'Logistics & Transportation', keywords: ['trucking', 'shipping', 'freight', 'courier', 'delivery'] },
  { label: 'Manufacturing', keywords: ['factory', 'production', 'assembly', 'fabrication'] },
  { label: 'Non-profit', keywords: ['charity', 'NGO', 'foundation', 'social enterprise'] },
  { label: 'Pet Services', keywords: ['veterinarian', 'dog walking', 'pet grooming', 'pet sitting', 'vet'] },
  { label: 'Pharmaceuticals', keywords: ['pharmacy', 'drug', 'clinical trials', 'pharma'] },
  { label: 'Professional Services', keywords: ['consulting', 'staffing', 'recruiting', 'HR'] },
  { label: 'Property Management', keywords: ['landlord', 'rental', 'property manager', 'tenant'] },
  { label: 'Real Estate', keywords: ['realtor', 'real estate agent', 'broker', 'property', 'housing'] },
  { label: 'Retail', keywords: ['store', 'shop', 'brick and mortar', 'merchandise', 'POS'] },
  { label: 'Security Services', keywords: ['security guard', 'surveillance', 'alarm', 'private security'] },
  { label: 'Software & SaaS', keywords: ['startup', 'app development', 'web development', 'dev', 'software company'] },
  { label: 'Telecommunications', keywords: ['telecom', 'phone', 'internet', 'wireless', 'ISP'] },
  { label: 'Other', keywords: [] },
];

export default function IndustryStep({ industry, onChange }: IndustryStepProps) {
  return (
    <div className="quiz-step">
      <div className="quiz-step__header">
        <h2 className="quiz-step__question">What industry are you in?</h2>
        <p className="quiz-step__helper">Every industry handles money differently - we'll match your plan to yours</p>
      </div>

      <div className="quiz-step__body">
        <Autocomplete
          placeholder="e.g., Software & SaaS"
          value={industry}
          onChange={onChange}
          options={INDUSTRIES}
        />
      </div>
    </div>
  );
}
